var map = {
	"./AW LOGO.png": 444,
	"./Booking/room1.png": 6983,
	"./Booking/room2-1.png": 6962,
	"./Booking/room3-1.jpg": 9879,
	"./Booking/room3-1.png": 7703,
	"./Food/food.png": 3154,
	"./News/frame-1.jpg": 2828,
	"./News/frame-10.jpg": 7310,
	"./News/frame-11.jpg": 8619,
	"./News/frame-12.jpg": 1644,
	"./News/frame-13.jpg": 6905,
	"./News/frame-14.jpg": 442,
	"./News/frame-15.jpg": 7959,
	"./News/frame-16.jpg": 680,
	"./News/frame-17.jpg": 4645,
	"./News/frame-18.jpg": 4534,
	"./News/frame-19.jpg": 9795,
	"./News/frame-2.jpg": 9275,
	"./News/frame-20.jpg": 9619,
	"./News/frame-21.jpg": 1094,
	"./News/frame-22.jpg": 8865,
	"./News/frame-23.jpg": 1492,
	"./News/frame-24.jpg": 2303,
	"./News/frame-25.jpg": 9634,
	"./News/frame-26.jpg": 8893,
	"./News/frame-27.jpg": 7968,
	"./News/frame-28.jpg": 9723,
	"./News/frame-3.jpg": 4494,
	"./News/frame-4.jpg": 5317,
	"./News/frame-5.jpg": 2952,
	"./News/frame-6.jpg": 7175,
	"./News/frame-7.jpg": 2714,
	"./News/frame-8.jpg": 7505,
	"./News/frame-9.jpg": 9460,
	"./RoomImage/room1-1.jpg": 1756,
	"./RoomImage/room1-2.jpg": 6923,
	"./RoomImage/room1-3.jpg": 1086,
	"./RoomImage2/room2-1.jpg": 477,
	"./RoomImage2/room2-2.jpg": 1986,
	"./RoomImage2/room2-3.jpg": 8335,
	"./RoomImage3/room3-1.jpg": 4673,
	"./RoomImage3/room3-2.jpg": 5094,
	"./RoomImage3/room3-3.jpg": 1907,
	"./Travel/amei.webp": 3163,
	"./Travel/wulai-1.webp": 1317,
	"./Travel/wulai-10.webp": 6651,
	"./Travel/wulai-11.webp": 1928,
	"./Travel/wulai-12.webp": 8453,
	"./Travel/wulai-13.webp": 4282,
	"./Travel/wulai-14.webp": 5479,
	"./Travel/wulai-15.webp": 4468,
	"./Travel/wulai-2.webp": 216,
	"./Travel/wulai-3.webp": 3019,
	"./Travel/wulai-4.webp": 1510,
	"./Travel/wulai-5.webp": 8785,
	"./Travel/wulai-6.webp": 9524,
	"./Travel/wulai-7.webp": 8887,
	"./Travel/wulai-8.webp": 4242,
	"./Travel/wulai-9.webp": 5581,
	"./back.png": 2460,
	"./book.7.jpg": 2875,
	"./booking.png": 1980,
	"./cart.png": 2807,
	"./change.png": 6461,
	"./forest.png": 1646,
	"./forest2.jpg": 6250,
	"./gym.82.jpg": 4466,
	"./hotel.jpg": 8011,
	"./left.png": 242,
	"./login.png": 1626,
	"./news.jpg": 5676,
	"./pool.32.jpg": 6362,
	"./right.png": 4015,
	"./room-1.png": 7154,
	"./room-2.png": 89,
	"./room.png": 9804,
	"./room1-1.jpg": 3921,
	"./room2-1.jpg": 1438,
	"./room2.jpg": 3699,
	"./room3-1.jpg": 7631,
	"./room3.jpg": 3181,
	"./spa.jpg": 9591,
	"./spa1.jpg": 8714,
	"./spa1/spa1-1.jpg": 7134,
	"./spa1/spa1-2.jpg": 5801,
	"./spa1/spa1.jpg": 1552,
	"./spa2.jpg": 9205,
	"./spa2/spa2-1.jpg": 4024,
	"./spa2/spa2-2.jpg": 6871,
	"./spa2/spa2.jpg": 8578,
	"./spa3.jpg": 8024,
	"./spa3/spa3-1.jpg": 7102,
	"./spa3/spa3-2.jpg": 2249,
	"./spa3/spa3.jpg": 4704,
	"./spring-1.png": 8816,
	"./spring-2.png": 6459,
	"./spring-3.png": 5330,
	"./spring-4.jpg": 3869,
	"./spring.png": 4306,
	"./user.png": 5056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3562;